/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onSlideChange = /* GraphQL */ `subscription OnSlideChange {
  onSlideChange {
    id
    url
    sequence
    type
    pollId
    pollResults {
      option
      percentage
      voteCount
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnSlideChangeSubscriptionVariables,
  APITypes.OnSlideChangeSubscription
>;
export const onMeetingStatusChange = /* GraphQL */ `subscription OnMeetingStatusChange {
  onMeetingStatusChange {
    eventid
    meetingstatusflag
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnMeetingStatusChangeSubscriptionVariables,
  APITypes.OnMeetingStatusChangeSubscription
>;
export const onSlideControlToggle = /* GraphQL */ `subscription OnSlideControlToggle {
  onSlideControlToggle {
    eventid
    enableSlideControl
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnSlideControlToggleSubscriptionVariables,
  APITypes.OnSlideControlToggleSubscription
>;
